(function() {
  const backendUrl = "https://stripe-connect-resonance.onrender.com";
  const connectedAccountId = "acct_1TZc5QPLC4PgO0Jd"; // State of Resonance Main/Platform Account ID

  const checkoutSelectors = [
    '[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    'button[type="submit"].checkout',
    'input[type="submit"][name="checkout"]',
    'a[href*="/checkout"]',
    'a[href*="/checkouts"]',
    'a[href*="/cart/checkout"]'
  ].join(', ');

  // Dynamic CSS injector for the premium checkout overlay & hiding Shopify checkout overrides
  function injectStyles() {
    if (document.getElementById('stripe-interceptor-styles')) return;
    const style = document.createElement('style');
    style.id = 'stripe-interceptor-styles';
    style.textContent = `
      /* Premium glassmorphic loader overlay */
      .resonance-checkout-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(11, 11, 15, 0.95);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        z-index: 9999999;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: opacity 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        pointer-events: none;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
      }
      .resonance-checkout-overlay.active {
        opacity: 1;
        pointer-events: auto;
      }
      .resonance-checkout-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 400px;
        padding: 2rem;
        text-align: center;
      }
      .resonance-spinner-box {
        position: relative;
        width: 80px;
        height: 80px;
        margin-bottom: 2rem;
      }
      .resonance-spinner-ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid transparent;
        border-top-color: #ec4899;
        border-bottom-color: #8b5cf6;
        animation: resonance-spin 1.5s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      }
      .resonance-spinner-glow {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        background: radial-gradient(circle, rgba(236, 72, 153, 0.2) 0%, rgba(139, 92, 246, 0) 70%);
        filter: blur(8px);
        animation: resonance-pulse 2s ease-in-out infinite alternate;
      }
      .resonance-logo-mark {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 1.5rem;
        font-weight: 800;
        color: #fff;
        letter-spacing: -0.05em;
        text-shadow: 0 0 10px rgba(255,255,255,0.3);
      }
      .resonance-checkout-title {
        font-size: 1.1rem;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: 0.15em;
        text-transform: uppercase;
        margin-bottom: 0.75rem;
        background: linear-gradient(135deg, #ffffff 30%, #ec4899 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .resonance-checkout-subtitle {
        font-size: 0.85rem;
        color: #8b8b9a;
        letter-spacing: 0.05em;
        line-height: 1.5;
        margin-bottom: 1.5rem;
      }
      .resonance-checkout-secure {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        background: rgba(255, 255, 255, 0.03);
        border: 1px solid rgba(255, 255, 255, 0.05);
        border-radius: 99px;
        padding: 0.4rem 1rem;
        font-size: 0.7rem;
        color: #8b8b9a;
        font-weight: 600;
        letter-spacing: 0.05em;
        text-transform: uppercase;
      }
      .resonance-secure-dot {
        width: 6px;
        height: 6px;
        background-color: #10b981;
        border-radius: 50%;
        box-shadow: 0 0 8px #10b981;
      }
      @keyframes resonance-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      @keyframes resonance-pulse {
        0% { transform: scale(0.9); opacity: 0.6; }
        100% { transform: scale(1.1); opacity: 1; }
      }

      /* Hide Shopify Accelerated Checkout / Dynamic Buy buttons to force Stripe flow */
      shop-pay-button,
      shopify-buy-it-now-button,
      .shopify-payment-button,
      .shopify-payment-button__button--unbranded,
      [data-shopify="payment-button"],
      .additional-checkout-buttons,
      .cart__dynamic-checkout-buttons,
      .cart-drawer__footer .additional-checkout-buttons,
      #additional-checkout-buttons,
      .shopify-payment-button__button {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
        visibility: hidden !important;
        height: 0 !important;
        padding: 0 !important;
        margin: 0 !important;
      }
    `;
    document.head.appendChild(style);
  }

  // Create loading overlay elements
  function createOverlay() {
    let overlay = document.getElementById('resonance-checkout-loader');
    if (overlay) return overlay;

    overlay = document.createElement('div');
    overlay.id = 'resonance-checkout-loader';
    overlay.className = 'resonance-checkout-overlay';
    overlay.innerHTML = `
      <div class="resonance-checkout-container">
        <div class="resonance-spinner-box">
          <div class="resonance-spinner-glow"></div>
          <div class="resonance-spinner-ring"></div>
          <div class="resonance-logo-mark">R</div>
        </div>
        <div class="resonance-checkout-title">Securing Connection</div>
        <div class="resonance-checkout-subtitle">Preparing checkout session with Stripe Connect...</div>
        <div class="resonance-checkout-secure">
          <span class="resonance-secure-dot"></span>
          <span>Resonance Secure Stripe Checkout</span>
        </div>
      </div>
    `;
    document.body.appendChild(overlay);
    return overlay;
  }

  function showLoader() {
    injectStyles();
    const loader = createOverlay();
    // Force a reflow
    loader.offsetHeight;
    loader.classList.add('active');
  }

  function hideLoader() {
    const loader = document.getElementById('resonance-checkout-loader');
    if (loader) {
      loader.classList.remove('active');
    }
  }

  let checkoutInitiated = false;

  // Main checkout interception function
  async function handleCheckout(event) {
    if (checkoutInitiated) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      return;
    }
    checkoutInitiated = true;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    showLoader();

    try {
      // 1. Fetch current Shopify cart (appended cache-buster to prevent cached items issues)
      const cartResponse = await fetch('/cart.js?v=' + Date.now());
      if (!cartResponse.ok) {
        throw new Error("Could not retrieve Shopify cart details.");
      }
      const cart = await cartResponse.json();

      if (!cart.items || cart.items.length === 0) {
        hideLoader();
        checkoutInitiated = false;
        alert("Your cart is currently empty.");
        return;
      }

      // 2. Format items for Stripe Connect Checkout endpoint
      const stripeItems = [];
      cart.items.forEach(item => {
        const title = item.title || item.product_title;
        
        // Extract properties and populate item-level metadata
        const metadata = {};
        if (item.properties && Object.keys(item.properties).length > 0) {
          for (const [key, value] of Object.entries(item.properties)) {
            if (value !== null && value !== undefined && value !== '') {
              // Stripe metadata keys: alphanumeric/underscores only, max 40 chars
              const cleanKey = key.replace(/[^a-zA-Z0-9_]/g, '').substring(0, 40);
              if (cleanKey) {
                metadata[cleanKey] = String(value).substring(0, 500);
              }
            }
          }
        }

        stripeItems.push({
          title: title,
          price: item.price, // Shopify prices are in cents
          quantity: item.quantity,
          currency: (cart.currency || 'usd').toLowerCase(),
          image: item.image,
          metadata: metadata
        });

        // Add Collector's Upgrade as a separate line item if selected
        let hasUpgrade = false;
        if (item.properties) {
          for (const [k, v] of Object.entries(item.properties)) {
            if (k.toLowerCase().replace(/['\s_]/g, '') === 'collectorsupgrade' && (v === 'Yes' || v === 'true' || v === 'yes' || v === true)) {
              hasUpgrade = true;
              break;
            }
          }
        }

        if (hasUpgrade) {
          stripeItems.push({
            title: `Collector's Upgrade (Crafting Video & Certificate) for ${item.product_title || item.title}`,
            price: 1500, // $15.00 in cents
            quantity: item.quantity,
            currency: (cart.currency || 'usd').toLowerCase(),
            image: item.image,
            metadata: {
              parent_config_id: item.properties._config_id || ''
            }
          });
        }
      });

      // 3. Initiate checkout session
      const checkoutResponse = await fetch(`${backendUrl}/api/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          accountId: connectedAccountId,
          items: stripeItems,
          success_url: `${backendUrl}/success.html?session_id={CHECKOUT_SESSION_ID}&shop=${window.location.hostname}&accountId=${connectedAccountId}`,
          cancel_url: `https://${window.location.hostname}/cart`,
          paymentMethodConfiguration: "pmc_1TZc5vPLC4PgO0JdljStthyN"
        })
      });

      if (!checkoutResponse.ok) {
        const errorData = await checkoutResponse.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to create secure Stripe Connect checkout session.");
      }

      const checkoutSession = await checkoutResponse.json();

      if (!checkoutSession.url) {
        throw new Error("Stripe Checkout URL missing from response.");
      }

      // Fire Meta Pixel InitiateCheckout event
      if (typeof fbq === 'function') {
        try {
          fbq('track', 'InitiateCheckout', {
            content_type: 'product',
            contents: cart.items.map(item => ({
              id: item.variant_id || item.id,
              quantity: item.quantity,
              item_price: item.price / 100
            })),
            value: cart.total_price / 100,
            currency: cart.currency || 'CAD'
          });
          console.log("Stripe Connect Interceptor: Fired Meta Pixel InitiateCheckout event.");
        } catch (fbErr) {
          console.warn("Stripe Connect Interceptor: Failed to fire Meta Pixel event:", fbErr);
        }
      }

      // 4. Redirect user to Stripe Connect Checkout Session
      window.location.href = checkoutSession.url;

    } catch (err) {
      console.error("Checkout redirection failed:", err);
      // Attempt fallback to Shopify checkout seamlessly
      console.warn("Stripe Connect checkout failed. Falling back to Shopify checkout...");
      window.location.href = "/checkout";

      // In case navigation is slow or fails, hide loader and allow retry after 5 seconds
      setTimeout(() => {
        hideLoader();
        checkoutInitiated = false;
      }, 5000);
    }
  }

  // Check if a form is a checkout form (includes buttons inside or outside pointing to it)
  function isCheckoutForm(form) {
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart') && !action.includes('/checkout')) {
      return false;
    }

    // Check if there is a checkout button inside the form
    if (form.querySelector('[name="checkout"], .cart__checkout-button, #checkout, [type="submit"].checkout')) {
      return true;
    }

    // Check if there is a checkout button outside the form pointing to this form
    if (form.id && document.querySelector(`[form="${form.id}"][name="checkout"], [form="${form.id}"].cart__checkout-button, [form="${form.id}"]#checkout`)) {
      return true;
    }

    return false;
  }

  // Sanitize all checkout buttons to type="button" and remove form attribute
  function sanitizeCheckoutButtons() {
    const selector = [
      '[name="checkout"]',
      '#checkout',
      '#CartDrawer-Checkout',
      '.cart__checkout-button',
      'button[type="submit"].checkout',
      'input[type="submit"][name="checkout"]'
    ].join(', ');

    document.querySelectorAll(selector).forEach(el => {
      if ((el.tagName === 'BUTTON' || el.tagName === 'INPUT') && el.type === 'submit') {
        el.type = 'button';
        console.log("Stripe Connect Interceptor: Sanitized checkout button type to button", el);
      }
      if (el.hasAttribute('form')) {
        el.removeAttribute('form');
        console.log("Stripe Connect Interceptor: Removed form attribute from checkout button", el);
      }
    });
  }

  // Bind listeners to any cart checkout triggers (capture phase)
  function bindCheckoutListeners() {
    // 1. Intercept early interaction events in the capture phase to stop other libraries/scripts (like Shopify's shop-js / Shop Pay checkout hijacking)
    const interactionEvents = ['touchstart', 'pointerdown', 'mousedown', 'mouseup'];
    interactionEvents.forEach(eventType => {
      document.addEventListener(eventType, function(event) {
        const target = event.target.closest(checkoutSelectors);
        if (target) {
          console.log(`Stripe Connect Interceptor: captured and stopped propagation of ${eventType} on`, target);
          event.stopPropagation();
        }
      }, true);
    });

    // 2. Intercept click and touchend in the capture phase to trigger checkout and prevent defaults
    const triggerEvents = ['click', 'touchend'];
    triggerEvents.forEach(eventType => {
      document.addEventListener(eventType, function(event) {
        const target = event.target.closest(checkoutSelectors);
        if (target) {
          console.log(`Stripe Connect Interceptor: triggering checkout via ${eventType} on`, target);
          handleCheckout(event);
        }
      }, true);
    });

    // 3. Also intercept submit events on forms containing checkout indicators
    document.addEventListener('submit', function(event) {
      const form = event.target;
      if (isCheckoutForm(form)) {
        // Only intercept if the submitter is the checkout button, or if there is no submitter and the active element is not a quantity input/notes field
        const submitter = event.submitter;
        let isCheckoutSubmit = false;
        if (submitter) {
          if (submitter.name === 'checkout' || submitter.id === 'checkout' || submitter.classList.contains('cart__checkout-button') || submitter.closest(checkoutSelectors)) {
            isCheckoutSubmit = true;
          }
        } else {
          // Fallback when submitter is null (e.g. submitted via enter key, or some other programmatic/system submission)
          const activeEl = document.activeElement;
          const isInputActive = activeEl && (
            activeEl.name === 'updates[]' || 
            activeEl.classList.contains('quantity__input') || 
            activeEl.tagName === 'INPUT' || 
            activeEl.tagName === 'TEXTAREA' || 
            activeEl.tagName === 'SELECT'
          );
          if (!isInputActive) {
            isCheckoutSubmit = true;
          }
        }

        if (isCheckoutSubmit) {
          console.log("Stripe interceptor caught checkout form submit event:", form);
          handleCheckout(event);
        } else {
          console.log("Stripe interceptor ignored non-checkout form submit event:", form);
        }
      }
    }, true);
  }

  // Observe and hide dynamic buttons & sanitize checkout buttons continuously
  function observeDOMChanges() {
    const hideSelector = [
      'shop-pay-button',
      'shopify-buy-it-now-button',
      '.shopify-payment-button',
      '.shopify-payment-button__button--unbranded',
      '[data-shopify="payment-button"]',
      '.additional-checkout-buttons',
      '.cart__dynamic-checkout-buttons',
      '.cart-drawer__footer .additional-checkout-buttons',
      '#additional-checkout-buttons'
    ].join(', ');

    function processElements() {
      // 1. Hide Shopify accelerated buttons
      document.querySelectorAll(hideSelector).forEach(el => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
      });

      // 2. Sanitize standard checkout buttons
      sanitizeCheckoutButtons();
    }

    // Run immediately
    processElements();

    // Use MutationObserver to catch elements dynamically added or updated
    const observer = new MutationObserver(processElements);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // Monkey-patch HTMLFormElement.prototype.submit to intercept programmatic submissions (e.g. from global.js/theme scripts)
  function patchFormSubmit() {
    const originalSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function() {
      if (isCheckoutForm(this)) {
        console.log("Stripe Connect interceptor intercepted programmatic form.submit() call.");
        handleCheckout();
      } else {
        originalSubmit.apply(this, arguments);
      }
    };

    if (typeof HTMLFormElement.prototype.requestSubmit === 'function') {
      const originalRequestSubmit = HTMLFormElement.prototype.requestSubmit;
      HTMLFormElement.prototype.requestSubmit = function(submitter) {
        if (isCheckoutForm(this)) {
          console.log("Stripe Connect interceptor intercepted programmatic form.requestSubmit() call.");
          handleCheckout();
        } else {
          originalRequestSubmit.apply(this, arguments);
        }
      };
    }
  }

  let lastPrewarmTime = 0;
  async function prewarmBackend() {
    const now = Date.now();
    // Debounce: Only prewarm once every 5 minutes to avoid rate limits
    if (now - lastPrewarmTime < 300000) return;
    lastPrewarmTime = now;

    console.log("Stripe Connect Interceptor: Optimistically pre-warming backend server...");
    try {
      fetch(`${backendUrl}/api/me`)
        .then(res => {
          if (res.ok) {
            console.log("Stripe Connect Interceptor: Backend server is awake and warm.");
          } else {
            console.warn("Stripe Connect Interceptor: Backend pre-warm ping returned status:", res.status);
          }
        })
        .catch(err => {
          console.warn("Stripe Connect Interceptor: Backend pre-warm ping failed (server may still be cold):", err.message);
        });
    } catch (e) {
      // ignore
    }
  }

  // Pre-warm when interacting with cart/checkout buttons
  function bindPrewarmListeners() {
    const triggers = ['mouseenter', 'touchstart', 'focusin'];
    triggers.forEach(eventType => {
      document.addEventListener(eventType, function(event) {
        if (event.target && typeof event.target.closest === 'function') {
          const isCheckoutBtn = event.target.closest(checkoutSelectors);
          const isCartDrawerTrigger = event.target.closest('#cart-icon-bubble, .header__icon--cart, [href="/cart"], .cart-count-bubble');
          if (isCheckoutBtn || isCartDrawerTrigger) {
            prewarmBackend();
          }
        }
      }, { passive: true });
    });
  }

  // Initialize immediately
  injectStyles();
  observeDOMChanges();
  patchFormSubmit();
  bindCheckoutListeners();
  bindPrewarmListeners();
  prewarmBackend();
})();
